import { useSearchParams } from "react-router-dom"

import { InvitationErrorCode } from "@/api/types"
import { ErrorMessage } from "@/components/error-message"
import { getErrorMessage } from "@/lib/error-messages"

const InvitationError = () => {
  const [searchParams] = useSearchParams()

  const errorCode = (searchParams.get("error_code") ||
    searchParams.get("code")) as InvitationErrorCode
  const errorMessage =
    searchParams.get("error_message") || searchParams.get("message")

  const { title, message, actionText } = getErrorMessage(
    errorCode,
    errorMessage,
  )

  return (
    <div className="mx-auto md:w-10/12 lg:w-8/12 xl:w-6/12">
      <ErrorMessage title={title}>
        <div className="flex flex-col gap-3">
          <p className="text-lg">{message}</p>
          <p className="text-muted-foreground">{actionText}</p>
        </div>
      </ErrorMessage>
    </div>
  )
}

export { InvitationError }
